const companyFoundedYear = 2018;

const yearsOfExperience = new Date().getFullYear() - companyFoundedYear;

const introFeatures = [
  "Licensed & fully insured contractors",
  `${yearsOfExperience} years of industry experience`,
  "On-time project delivery guarantee",
  "Transparent, no-surprise pricing",
];

export default introFeatures;